import React from "react";
import { motion } from "framer-motion";
import { Reveal } from "../ui/Reveal";
import { SectionTitle } from "../ui/SectionTitle";
import { CycleDiagram } from "./CycleDiagram";
import { EASE_OUT } from "../../utils/motion";
const paths = [{
  name: "Camino 1",
  title: "La Represión",
  steps: ["Te niegas el dulce. Comes una manzana.", "Sigues con el ansia.", "A las 8 de la noche, cuando los niños duermen, comes escondida tres porciones de lo primero que encuentres.", "Te sientes culpable. Mañana \"empiezas de nuevo\"."]
}, {
  name: "Camino 2",
  title: "La Transgresión",
  steps: ["Te das permiso. Comes un pedazo de torta.", "Se siente bien por 10 minutos.", "Luego viene la inflamación: el abdomen hinchado, la pesadez.", "El sentimiento de haber \"fallado\"."]
}];
const receipt = [{
  item: "Harina especial importada",
  value: "$25"
}, {
  item: "Endulzante \"fit\" de tienda especial",
  value: "$18"
}, {
  item: "Tiempo en la cocina",
  value: "2 h"
}, {
  item: "Textura rara",
  value: "✕"
}, {
  item: "Sabor a castigo",
  value: "✕"
}];
export function PainSection() {
  return <section className="bg-blush-light py-20 lg:py-28" data-id="element-302" data-mp="zuv0dzer6713">
      <div className="mx-auto max-w-6xl px-5" data-id="element-303" data-mp="zwfszjhibfwb">
        <div className="grid items-center gap-16 lg:grid-cols-2" data-id="element-304" data-mp="14t68a4lhm7go">
          <div data-id="element-305" data-mp="14rd18o6ypl85">
            <SectionTitle align="left" data-id="element-306" data-mp="1sja9y6f47x51">El Ciclo Que Te Tiene Atrapada</SectionTitle>
            <Reveal delay={0.05} className="mt-6 space-y-5 text-lg leading-relaxed text-cocoa-light" data-id="element-307" data-mp="1shfrqzv8aj4n">
              <p data-id="element-308" data-mp="1xg0ogpb9ukoc">Mira, ya sabes cómo es.</p>
              <p data-id="element-309" data-mp="1ik2osx252y7d">
                Intentas cuidarte. De verdad lo haces. Comes ensalada al mediodía, tomas agua, haces ejercicio. Pero cuando llegan las 4 de la
                tarde, algo en tu interior grita pidiendo dulce.
              </p>
              <p data-id="element-310" data-mp="781s8vz1a5h2">
                <b className="text-cocoa" data-id="element-311" data-mp="c50kta31u4d5">No es capricho.</b> Es tu cuerpo pidiendo placer, pidiendo esa dopamina que siente que se merece.
              </p>
            </Reveal>
          </div>
          <div className="px-8 py-10" data-id="element-312" data-mp="29smcq0ynnbsy">
            <CycleDiagram data-id="element-313" data-mp="29tnoy8req4c9" />
          </div>
        </div>

        <Reveal className="mt-20 text-center" data-id="element-314" data-mp="29uyuoe4exm60">
          <p className="text-lg font-semibold text-cocoa" data-id="element-315" data-mp="250umxsnbpa3v">Entonces tienes dos caminos:</p>
        </Reveal>
        <div className="mt-8 grid gap-6 md:grid-cols-2" data-id="element-316" data-mp="20204irt9pnka">
          {paths.map((p, i) => <Reveal key={p.name} delay={i * 0.08} className="h-full" data-id="element-317" data-mp="1v4rlyq47jhii" data-mpi={i}>
              <article className="flex h-full flex-col rounded-3xl bg-white p-7 shadow-[0_20px_50px_-30px_rgba(59,34,25,0.45)] sm:p-9" data-id="element-318" data-mp="1r1lghkox5ud3">
                <p className="text-sm font-bold text-berry" data-id="element-319" data-mp="1m3tge3e4f1xt">{p.name}</p>
                <h3 className="mt-1 font-display text-3xl font-bold text-cocoa" data-id="element-320" data-mp="1h4qjj68ao20x">{p.title}</h3>
                <ol className="mt-6 space-y-4 border-l-2 border-dashed border-blush-dark pl-6" data-id="element-321" data-mp="3ghkubf3hg7z2">
                  {p.steps.map((s, j) => <li key={s} className="relative text-cocoa-light" data-id="element-322" data-mp="3birgflkaaeyd" data-mpi={j}>
                      <span className={`absolute -left-[31px] top-1.5 h-3 w-3 rounded-full ${j === p.steps.length - 1 ? "bg-berry" : "bg-blush-dark"}`} data-id="element-323" data-mp="3j0fwfsi7p0r5" />
                      {s}
                    </li>)}
                </ol>
              </article>
            </Reveal>)}
        </div>

        <div className="mt-24 grid items-center gap-14 lg:grid-cols-[1.2fr_1fr]" data-id="element-324" data-mp="1joaqs1phbpx">
          <Reveal className="space-y-5 text-lg leading-relaxed text-cocoa-light" data-id="element-325" data-mp="303og9rxyv1rb">
            <p className="font-display text-2xl font-bold text-cocoa sm:text-3xl" data-id="element-326" data-mp="3516g8su0a6n6">Lo peor es que has intentado la "solución saludable".</p>
            <p data-id="element-327" data-mp="39z7zbdrfm5yn">
              Buscaste en YouTube. Encontraste esas recetas que dicen "brownie sin azúcar" o "galletas fit". Gastaste dinero en ingredientes que{" "}
              <b className="text-cocoa" data-id="element-328" data-mp="pbd6kidqkibm">NO EXISTEN en tu supermercado local</b>, pasaste 2 horas en la cocina, y el resultado fue...
              decepcionante.
            </p>
            <p data-id="element-329" data-mp="ruqb6a5q0lk2">Una textura rara. Un sabor que te recordaba que estabas "castigándote" por cuidarte.</p>
          </Reveal>

          <motion.div initial={{
          opacity: 0,
          y: 20,
          rotate: 0
        }} whileInView={{
          opacity: 1,
          y: 0,
          rotate: 2
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: EASE_OUT
        }} className="mx-auto w-full max-w-sm bg-white p-6 font-mono text-sm text-cocoa shadow-[0_25px_50px_-20px_rgba(59,34,25,0.45)]" aria-label="Ticket de la receta fit fallida" data-id="element-330" data-mp="nu6f79wvvnzi">
            <p className="text-center font-bold uppercase tracking-widest" data-id="element-331" data-mp="16s0kbcuw5fcm">Receta "fit" de internet</p>
            <p className="mt-1 text-center text-xs text-cocoa-light" data-id="element-332" data-mp="1kivuqtl1g4ib">Ticket #0004 · 16:00</p>
            <div className="my-4 border-t border-dashed border-cocoa/30" data-id="element-333" data-mp="1flcj81fq65u2" />
            <ul className="space-y-2" data-id="element-334" data-mp="1uiwiqstur8su">
              {receipt.map(r => <li key={r.item} className="flex justify-between gap-4" data-id="element-335" data-mp="1pja4cg2afmig">
                  <span data-id="element-336" data-mp="294k60mvcqtfx">{r.item}</span>
                  <span className={r.value === "✕" ? "font-bold text-berry" : "font-bold"} data-id="element-337" data-mp="295lhutk6zjyp">{r.value}</span>
                </li>)}
            </ul>
            <div className="my-4 border-t border-dashed border-cocoa/30" data-id="element-338" data-mp="1z6creaojcnh3" />
            <div className="flex justify-between text-base font-bold" data-id="element-339" data-mp="1z64fal08lm6y">
              <span data-id="element-340" data-mp="2445vmy6a37eq">TOTAL</span>
              <span className="text-berry" data-id="element-341" data-mp="247jzkaulbooa">Decepción</span>
            </div>
          </motion.div>
        </div>

        <Reveal className="mx-auto mt-24 max-w-3xl text-center" data-id="element-342" data-mp="1peq6fmmeba15">
          <p className="font-display text-2xl font-bold text-cocoa sm:text-3xl" data-id="element-343" data-mp="1u8ufqcj4vu5e">¿Y sabes qué es lo peor?</p>
          <p className="mt-5 text-lg leading-relaxed text-cocoa-light" data-id="element-344" data-mp="1ghpo9xpx6865">
            Que seguiste viviendo en ese ciclo de restricción-culpa-ansia porque asumiste que el problema eras TÚ. Que tenías "poca fuerza de
            voluntad". Que simplemente no podías disfrutar de los dulces.
          </p>
          <motion.p initial={{
          opacity: 0,
          scale: 0.96
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: 0.15,
          ease: EASE_OUT
        }} className="mt-10 inline-block rounded-2xl bg-cocoa px-8 py-4 font-display text-3xl font-bold italic text-cream shadow-xl sm:text-4xl" data-id="element-345" data-mp="1bg08y5vnz8c9">
            Pero no es así.
          </motion.p>
        </Reveal>
      </div>
    </section>;
}